export default class DiscountBarItemModel {
  originalData = null;
  constructor(data) {
    this.originalData = data;
  }
}
